
document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartDrawer', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'switch:cart:afteradditem',
            () => {

              Object.keys(Alpine.store('modals').modals).forEach((modal) => {
                Alpine.store('modals').close(modal);
              });

              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});

/*
document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartDrawer', ({ openOnAddToCart }) => {
    return {
      // -------------------------------
      // INIT
      // -------------------------------
      init() {
        Alpine.store('modals').register('cart', 'rightDrawer');

        // Bind handlers once
        this.boundQtyInputHandler = this.qtyInputHandler.bind(this);
        this.boundRemoveBtnHandler = this.removeBtnHandler.bind(this);
        this.boundDecrementHandler = this.decrementHandler.bind(this);
        this.boundIncrementHandler = this.incrementHandler.bind(this);

        // Initial setup
        this.refreshAll();

        // Open drawer on add to cart if enabled
        if (openOnAddToCart === true) {
          document.body.addEventListener('switch:cart:afteradditem', () => {
            Object.keys(Alpine.store('modals').modals).forEach((modal) => {
              Alpine.store('modals').close(modal);
            });
            Alpine.store('modals').open('cart');
            this.refreshAll();
          });
        }

        // Listen for cart updates/removals
        document.body.addEventListener('switch:cart:update', () => this.refreshAll());
        document.body.addEventListener('switch:cart:removeitem', () => this.refreshAll());
      },

      // -------------------------------
      // REFRESH ALL
      // -------------------------------
      refreshAll() {
        this.refreshCartData();
        this.setupQtyInputs();
        this.setupRemoveButtons();
        this.setupPlusMinusButtons();
      },

      // -------------------------------
      // CART DATA / LIVE UPDATES
      // -------------------------------
      refreshCartData() {
        fetch('/cart.json', { credentials: 'same-origin' })
          .then(res => res.json())
          .then(cart => {
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);
          })
          .catch(err => console.error('Error fetching cart:', err));
      },

      updateShippingBar(cart) {
        const threshold = 32900; // Free shipping threshold in cents
        const shippingBarMessage = document.getElementById('CartShippingBarMessage');
        if (!shippingBarMessage) return;

        const remaining = threshold - cart.total_price;

        if (remaining <= 0) {
          shippingBarMessage.innerText = '🎉 You qualify for free shipping!';
        } else {
          shippingBarMessage.innerText = `Add $${(remaining / 100).toFixed(2)} more to get free shipping!`;
        }
      },

      updateLiveRegion(cart) {
        const liveRegion = document.getElementById('cart-live-region-text');
        if (!liveRegion) return;
        liveRegion.innerText = `New subtotal: $${(cart.total_price / 100).toFixed(2)}`;
      },

      // -------------------------------
      // QUANTITY INPUT
      // -------------------------------
      setupQtyInputs() {
        document.querySelectorAll('.qty-input[data-line]').forEach(input => {
          input.removeEventListener('change', this.boundQtyInputHandler);
          input.addEventListener('change', this.boundQtyInputHandler);
        });
      },

      qtyInputHandler(event) {
        let quantity = parseInt(event.target.value);
        if (isNaN(quantity) || quantity < 1) {
          quantity = 1;
          event.target.value = quantity;
        }
        const line = parseInt(event.target.dataset.line);
        this.updateCartLine(line, quantity);
      },

      // -------------------------------
      // REMOVE BUTTON
      // -------------------------------
      setupRemoveButtons() {
        document.querySelectorAll('.remove-item-btn[data-line]').forEach(btn => {
          btn.removeEventListener('click', this.boundRemoveBtnHandler);
          btn.addEventListener('click', this.boundRemoveBtnHandler);
        });
      },

      removeBtnHandler(event) {
        event.preventDefault();
        const line = parseInt(event.currentTarget.dataset.line);
        this.updateCartLine(line, 0, 'switch:cart:removeitem');
      },

      // -------------------------------
      // PLUS / MINUS BUTTONS
      // -------------------------------
      setupPlusMinusButtons() {
        document.querySelectorAll('button[aria-label="-"]').forEach(btn => {
          btn.removeEventListener('click', this.boundDecrementHandler);
          btn.addEventListener('click', this.boundDecrementHandler);
        });

        document.querySelectorAll('button[aria-label="+"]').forEach(btn => {
          btn.removeEventListener('click', this.boundIncrementHandler);
          btn.addEventListener('click', this.boundIncrementHandler);
        });
      },

      decrementHandler(event) {
        event.preventDefault();
        const input = event.currentTarget.closest('div')?.querySelector('input.qty-input[data-line]');
        if (!input) return;

        let quantity = Math.max((parseInt(input.value) || 1) - 1, 1);
        input.value = quantity;
        const line = parseInt(input.dataset.line);
        this.updateCartLine(line, quantity);
      },

      incrementHandler(event) {
        event.preventDefault();
        const input = event.currentTarget.closest('div')?.querySelector('input.qty-input[data-line]');
        if (!input) return;

        let quantity = (parseInt(input.value) || 1) + 1;
        input.value = quantity;
        const line = parseInt(input.dataset.line);
        this.updateCartLine(line, quantity);
      },

      // -------------------------------
      // SHARED CART UPDATE FUNCTION
      // -------------------------------
      updateCartLine(line, quantity, eventName = 'switch:cart:update') {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ line, quantity }),
        })
          .then(res => res.json())
          .then(cart => {
            // Update shipping bar & live region immediately
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);

            // Trigger event for other theme JS
            document.body.dispatchEvent(new Event(eventName));
          })
          .catch(err => console.error('Error updating cart:', err));
      }
    };
  });
});
*/